'use client'

import React from 'react'
import Link from 'next/link'
import { Trans, useTranslation } from 'react-i18next'
import { Faq } from '@/components/site/faq'
import { Reveal } from '@/components/site/reveal'
import { SectionHead } from '@/components/site/section-head'
import { SiteSection } from '@/components/site/section'
import { trackSiteLinkClicked } from '@/lib/analytics'

export function HomeFaqSection() {
  const { t } = useTranslation(['web'])
  return (
    <SiteSection id="faq" trackingKey="faq" className="scroll-mt-[84px]">
      <Reveal>
        <SectionHead eyebrow={t('web:homePage.faq.eyebrow')} titleKey="web:homePage.faq.title" />
      </Reveal>
      <Reveal className="mt-(--gap-lg)">
        <Faq
          items={[1, 2, 3, 4, 5].map((number) => ({
            key: `q${number}`,
            question: t(`web:homePage.faq.q${number}`),
            answers: [
              <Trans
                key={number}
                t={t}
                i18nKey={`web:homePage.faq.a${number}`}
                components={{
                  pricing: (
                    <Link
                      href="/pricing"
                      onClick={() => trackSiteLinkClicked('faq', '/pricing')}
                      className="border-b border-brand/34 font-normal text-brand transition-colors hover:border-brand-hover hover:text-brand-hover focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand"
                    />
                  ),
                }}
              />,
            ],
          }))}
        />
      </Reveal>
    </SiteSection>
  )
}
